import { Column, Entity, JoinColumn, ManyToOne } from "typeorm";
import { CxAnswerHeader } from "./cx-answer-header.entity";
import { CommonColumns } from "./common-columns.entity";
import { CxQuestion, QuestionType } from "./cx-question.entity";

@Entity()
export class CxAnswer extends CommonColumns {

  @ManyToOne(() => CxAnswerHeader, cxAnswerHeadr => cxAnswerHeadr.cxAnswers, { nullable: false, })
  @JoinColumn({ name: 'cx_answer_header_id', referencedColumnName: 'id', })
  cxAnswerHeader: CxAnswerHeader;

  @ManyToOne(() => CxQuestion, { nullable: false, })
  @JoinColumn({ name: 'cx_question_id', referencedColumnName: 'id', })
  cxQuestion: CxQuestion;

  // 質問内容は編集される可能性がある
  // 回答時の質問内容をコピーしておく
  @Column({
    name: 'question_type',
    enum: QuestionType,
  })
  questionType: QuestionType;

  // 質問内容は編集される可能性がある
  // 回答時の質問内容をコピーしておく
  @Column({ name: 'question_text', })
  questionText: string;
  
  @Column({ name: 'disp_order', })
  dispOrder: number;

  @Column({ name: 'answer_value', length: 400, })
  answerValue: string;

  @Column({ name: 'answer_sub_value', length: 130, default: '', })
  answerSubValue: string;

  @Column({ name: 'is_nps', })
  isNps: boolean;

  @Column({ name: 'is_nps_comment', })
  isNpsComment: boolean;

  // 便宜上、SELECT_SCORE以外の質問タイプの時も設定する
  @Column({ name: 'max_score', default: 5, })
  maxScore: number;

  @Column({ name: 'question_no', })
  questionNo: number;



  constructor(props: ICxAnswer) {
    super();
    Object.assign(this, props);
  }
}

export declare type TCxAnswer = Omit<CxAnswer, 'dummy-no-such-field'>;
export interface ICxAnswer extends TCxAnswer {};
